import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISheetsState } from "./definitions";
import { ReactNode } from "react";

const initialState: ISheetsState = {
    children: null,
    sheetStack: [],
    isSheetsOpen: false,
    sheetWidth: "990px",
};

export const sheetsSlice = createSlice({
    name: "sheets",
    initialState,
    reducers: {
        updateSheetChildren: (
            state,
            action: PayloadAction<{
                content: React.ReactNode;
                width?: string | number;
            }>
        ) => {
            state.children = action.payload.content;
            state.sheetWidth = action.payload.width || state.sheetWidth;
        },
        updateSheetState: (state, action: PayloadAction<boolean>) => {
            state.isSheetsOpen = action.payload;
        },
        pushSheet: (
            state,
            action: PayloadAction<{
                content: ReactNode;
                width: string | number;
                id?: string;
            }>
        ) => {
            state.sheetStack?.push({
                content: action.payload.content,
                width: action.payload.width.toString(),
                id: action.payload.id,
            });
        },
        closeSheetById: (state, action: PayloadAction<string | undefined>) => {
            if (action.payload) {
                state.sheetStack = state.sheetStack.filter(sheet => sheet.id !== action.payload);

                if (state.sheetStack.length === 0) {
                    state.isSheetsOpen = false;
                }
            }
        },
    },
});

export const { updateSheetChildren, updateSheetState, pushSheet, closeSheetById } =
    sheetsSlice.actions;

export const sheetsReducer = sheetsSlice.reducer;
